export const tableFilterTexts = {
  placeholder: {
    notes: 'Placeholder text in filter field for table columns',
    message: 'Filter',
  },
  range: {
    from: {
      notes: 'Range filter from field label',
      message: 'From',
    },
    to: {
      notes: 'Range filter to field label',
      message: 'To',
    },
  },
  number: {
    disabled: {
      notes: 'Number filter in table has no values to filter on',
      message: 'No values to filter on',
    },
  },
};
